export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautifully%20curated%20flat%20lay%20of%20assorted%20fashion%20and%20lifestyle%20products%20including%20a%20smartphone%20notebook%20coffee%20cup%20and%20fabric%20swatches%20on%20a%20light%20wooden%20desk%2C%20warm%20morning%20sunlight%20from%20large%20window%2C%20airy%20fresh%20composition%2C%20soft%20natural%20shadows%2C%20creative%20workspace%20aesthetic%2C%20editorial%20photography%20with%20gentle%20warm%20tones&width=1800&height=1200&seq=hero-v2-main-2026&orientation=landscape"
          alt="ItaobuySpreadsheet product sourcing system background"
          title="ItaobuySpreadsheet - Smart Product Sourcing System"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>

      {/* Content - Left Bottom */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-28 px-4 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          {/* Pill Tag */}
          <span className="inline-block px-4 py-1.5 text-xs font-medium border border-background-50/40 text-background-50 rounded-full backdrop-blur-sm mb-6">
            Smart Sourcing System
          </span>

          {/* H1 */}
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 leading-[1.15] mb-4">
            <span className="block font-bold">ItaobuySpreadsheet</span>
            <span className="block italic font-normal text-background-50/90 mt-1">The Smart Sourcing System</span>
          </h1>

          {/* Subtitle */}
          <p className="text-sm md:text-base text-background-50/80 max-w-md mb-8 leading-relaxed">
            Discover products faster. Compare suppliers easily. Scale your online business with the structured itaobuyspreadsheet ecosystem.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-6 py-3 text-sm font-medium border border-background-50/60 text-background-50 rounded-full hover:bg-background-50/10 smooth-transition whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              itaobuy sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 smooth-transition whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 rounded-full bg-background-50/20 flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-line text-background-50 text-xs"></i>
              </span>
              buy it now
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}